import {
  normalizeLanguageCode,
  buildResponseLanguagePreferenceMemory,
  parseResponseLanguagePreferenceMemory,
} from "~shared/chatPersonalization";

export { normalizeLanguageCode, buildResponseLanguagePreferenceMemory, parseResponseLanguagePreferenceMemory };

export function getLanguageDisplayName(languageCode: string, locale: string = "en"): string {
  const normalized = normalizeLanguageCode(languageCode);
  if (!/^[a-z]{2}(-[a-z]{2})?$/.test(normalized)) {
    return normalized.toUpperCase();
  }
  try {
    const displayNames = new Intl.DisplayNames([locale], { type: "language" });
    return displayNames.of(normalized) ?? normalized.toUpperCase();
  } catch {
    return normalized.toUpperCase();
  }
}

export function formatLanguagePreferenceDisplayText(languageCode: string): string {
  return `Always reply in ${getLanguageDisplayName(languageCode)} unless I ask otherwise.`;
}
